/** @jsxImportSource @emotion/react */

import { COLORS } from '@btime/constants'
import { css } from '@emotion/react'
import React from 'react'

import { SmallText } from './Text'

export const StaticCounter = ({ value, alertNote, color }) => {
  const size = alertNote ? '0.4rem' : '1rem'

  const style = css`
    & > .value {
      border-radius: 5rem;
      height: ${size};
      width: ${size};
      background: ${color || COLORS.purple};
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `

  return (
    <div css={style} className="static-counter">
      <SmallText size="xxsmall" bold color={COLORS.white} className="value">
        {!alertNote && value}
      </SmallText>
    </div>
  )
}

const Counter = ({ value, children, alertNote, ...props }) => {
  if (!value && !alertNote) return children
  const distanceTop = alertNote ? '0' : '-5px'

  const style = css`
    position: relative;

    & > .static-counter {
      position: absolute;
      top: ${distanceTop};
      right: -5px;
    }
  `

  return (
    <div css={style} className="counter">
      <StaticCounter value={value} alertNote={alertNote} {...props} />
      {children}
    </div>
  )
}

export default Counter
